<template>
  <v-sheet class="pb-10">
    <v-snackbar
      v-model="snackbar"
      color="success"
      :timeout="5000"
      top
    >
      Ваши данные успешно обновлены!
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Закрыть
      </v-btn>
    </v-snackbar>
    <v-breadcrumbs :items="breadcrumbs_items" large></v-breadcrumbs>
    <v-container>
      <PasswordChangeForm @showSnackbar="onShowSnackbar"></PasswordChangeForm>
    </v-container>
  </v-sheet>
</template>

<script>
  import {mapGetters, mapMutations} from "vuex";
  import PasswordChangeForm from "../../components/profile/settings/PasswordChangeForm";

  export default {
    name: "Settings",
    components: {
      PasswordChangeForm,
    },
    data() {
      return {
        breadcrumbs_items: [
          {text: 'Личный кабинет', disabled: false, to: {name: 'profile_application_list'}},
          {text: 'Настройки', disabled: true},
        ],
        snackbar: false,
      }
    },
    computed: {
      ...mapGetters("context", [
        'isLoading',
        'messages',
      ]),
      ...mapMutations("context", [
        'CLEAR_MESSAGES',
      ]),
    },
    methods: {
      onShowSnackbar(value) {
        this.snackbar = value;
      },
    }
  }
</script>
